import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { ConnectionService } from '../../service/connection.service';
import { SwalService } from '../../service/swal.service';
import { SubscriptionService } from '../../service/subscription.service';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { IconComponent } from '../../components/icon/icon.component';
import { LoadErrorComponent } from '../../components/load-error/load-error.component';

@Component({
  selector: 'app-collaborazioni',
  templateUrl: './collaborazioni.component.html',
  styleUrls: ['./collaborazioni.component.css'],
  imports: [CommonModule, FormsModule, RouterLink, TranslatePipe, IconComponent, LoadErrorComponent],
})
export class CollaborazioniComponent implements OnInit {
  team: any[] = [];
  teamLoaded = false;
  editingTeamIndex = -1;
  nyzedUserCheck: Record<number, boolean> = {};
  private editSnapshot: any = null;

  constructor(
    private connection: ConnectionService,
    private swal: SwalService,
    private cdr: ChangeDetectorRef,
    private subscription: SubscriptionService,
    private router: Router,
    private translate: TranslateService,
  ) {}

  private t(key: string): string {
    return this.translate.instant(`profile.rubrica.${key}`);
  }

  get canPro(): boolean {
    return this.subscription.canPro();
  }

  goToPlans() {
    this.router.navigate(['/abbonamenti']);
  }

  ngOnInit() {
    this.subscription.loadEntitlements();
    this.load();
  }

  // Rubrica non arrivata: niente modifiche, il salvataggio riscrive l'intera lista
  loadError = false;

  load() {
    this.connection.get(
      'auth/profile',
      (data: any) => {
        this.loadError = false;
        this.team = data.team ?? [];
        this.teamLoaded = true;
        this.team.forEach((m, i) => {
          if (m.email) this.checkNyzedUser(m.email, i);
        });
      },
      () => (this.loadError = !this.teamLoaded),
    );
  }

  // Referral / pubblicità: invita un contatto a iscriversi su Nyzed (nessun accesso)
  inviteToNyzed(email: string, name?: string) {
    this.connection.post(
      'auth/referral',
      { email, name },
      () => this.swal.success(this.t('invite_sent')),
      (err: any) =>
        this.swal.error(err?.error?.message ?? this.t('invite_error')),
    );
  }

  removeTeamMember(i: number) {
    this.swal
      .confirm(this.t('remove_title'), this.t('remove_text'))
      .then((result) => {
        if (result.isConfirmed) {
          this.team.splice(i, 1);
          this.editingTeamIndex = -1;
          this.editSnapshot = null;
          this.nyzedUserCheck = {};
          this.team.forEach((m, idx) => {
            if (m.email) this.checkNyzedUser(m.email, idx);
          });
          this.saveTeam();
        }
      });
  }

  saveTeam() {
    if (!this.teamLoaded) return;
    this.connection.put(
      'auth/team',
      { team: this.team },
      () => this.swal.success(this.t('saved')),
      () => this.swal.errorDialog(this.translate.instant('swal.error'), this.t('save_error')),
    );
  }

  addTeamMember() {
    if (!this.subscription.requirePro(this.t('pro_lock'))) {
      return;
    }
    this.team.push({
      name: '',
      lastname: '',
      email: '',
      notes: '',
      available: true,
      service: { hair: false, makeup: false, photo: false },
    });
    this.editingTeamIndex = this.team.length - 1;
    this.editSnapshot = null;
  }

  startEdit(i: number) {
    if (this.editingTeamIndex >= 0) this.cancelEdit(this.editingTeamIndex);
    this.editSnapshot = JSON.parse(JSON.stringify(this.team[i]));
    if (!this.team[i].service) this.team[i].service = { hair: false, makeup: false, photo: false };
    this.editingTeamIndex = i;
  }

  // Annulla: una voce nuova mai salvata sparisce, una esistente torna com'era
  cancelEdit(i: number) {
    if (this.editSnapshot) {
      this.team[i] = this.editSnapshot;
    } else if (!this.team[i]?.name?.trim()) {
      this.team.splice(i, 1);
    }
    this.editSnapshot = null;
    this.editingTeamIndex = -1;
  }

  initials(m: any): string {
    return `${m?.name?.charAt(0) ?? ''}${m?.lastname?.charAt(0) ?? ''}`.toUpperCase() || '?';
  }

  roleKeys(service: any): string[] {
    const keys: string[] = [];
    if (service?.makeup) keys.push('profile.trucco');
    if (service?.hair) keys.push('profile.capelli');
    if (service?.photo) keys.push('profile.foto');
    return keys;
  }

  saveTeamMember(i: number) {
    if (!this.team[i].name?.trim()) {
      this.swal.error(this.t('name_required'));
      return;
    }
    this.editingTeamIndex = -1;
    this.editSnapshot = null;
    this.saveTeam();
  }


  checkNyzedUser(email: string, index: number) {
    if (!email) {
      this.nyzedUserCheck = { ...this.nyzedUserCheck, [index]: false };
      return;
    }
    this.connection.get(
      `@auth/check-email?email=${encodeURIComponent(email)}`,
      (res: any) => {
        this.nyzedUserCheck = {
          ...this.nyzedUserCheck,
          [index]: res.isWedoUser,
        };
        this.cdr.detectChanges();
      },
      () => {},
    );
  }
}
